import { useEffect } from "react";
import Select from "react-select";
import { Link2, X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";

import "./Styles/Styles.scss";
import { fetchHomePage } from "../../Pages/Home/home_actions";
import HeadingColors from "../../views/ui-elements/typography/HeadingColors";

const iconData = [
  { src: "youtube_icon.png", width: 30 },
  { src: "instagram_icon.png", width: 28 },
  { src: "tiktok_icon.png", width: 30 },
  // { src: "facebook_icon.png", width: 30 },
];

const AllIcons = (
  <div className="d-flex gap-3 justify-content-center mt-4">
    {iconData.map((icon, index) => (
      <div key={index} className="d-flex align-items-center">
        <img
          src={require(`@src/assets/images/vyrill/icons/${icon.src}`).default}
          width={icon.width}
        />
      </div>
    ))}
  </div>
);

const Step1AddUrl = ({
  open,
  videoUrls,
  videoType,
  handleChange,
  setVideoURL,
  uploadVideoDetails,
  handleClose,
  handleSubmit,
  fetchLoading,
  setVideoType,
  setStep1Modal,
  setUploadVideoModal,
  setSingleVideoDetail,
}) => {
  const { addCompetitorVideo } = useSelector((state) => state.videoData);
  const { errors } = useSelector((state) => state);
  const { validationErrors } = errors;
  const dispatch = useDispatch();

  const URLHandler = () => {
    const detectPlatform = (url) => {
      // disabled facebook for now
      // if (url.includes("facebook.com")) {
      //   return "Facebook";
      // } else
      if (url.includes("instagram.com")) {
        return "Instagram";
      } else if (url.includes("youtube.com") || url.includes("youtu.be")) {
        return "YouTube";
      } else if (url.includes("tiktok.com")) {
        return "TikTok";
      }
      return null;
    };

    return (
      <PerfectScrollbar
        className="scrollable-container media-list"
        options={{ wheelPropagation: false }}
      >
        {videoUrls.map((element, index) => (
          <div key={index}>
            <Input
              className="VideoURLInput"
              type="text"
              name="video_url"
              id="video_url"
              value={element}
              onChange={(e) => {
                const platform = detectPlatform(e.target.value);
                if (platform) {
                  setVideoType({ value: platform });
                } else {
                  setVideoType(null);
                }
                handleChange(index, e);
              }}
              placeholder="Add your video link here"
            />
          </div>
        ))}
      </PerfectScrollbar>
    );
  };

  // Show message to user if the remaining video upload limit is less than or equal to 10
  const notificationBand = () => {
    return (
      uploadVideoDetails &&
      uploadVideoDetails.video_upload_limit &&
      uploadVideoDetails.video_upload_limit -
        uploadVideoDetails.uploaded_videos <=
        10 && (
        <div className="notificationBand w-100 p-1 text-center">
          You have{" "}
          <strong>
            {uploadVideoDetails.video_upload_limit &&
              uploadVideoDetails.video_upload_limit -
                uploadVideoDetails.uploaded_videos}{" "}
            video uploads
          </strong>{" "}
          left. Contact
          <span style={{ color: "#783AD0" }}>
            {" "}
            <a href="mailto:sales@vyrill.com">sales@vyrill.com</a>{" "}
          </span>
          to upgrade your plan
        </div>
      )
    );
  };

  const uplaodVideoBtn = (
    <p
      className="d-flex flex-column align-items-center"
      style={{ color: "#783AD0", fontSize: "20px" }}
      role="button"
      onClick={() => {
        setStep1Modal(false);
        setUploadVideoModal(true);
        setSingleVideoDetail({});
        setVideoType("");
        // setVideoURL("");
      }}
    >
      Upload Video
    </p>
  );

  useEffect(() => {
    if (addCompetitorVideo) {
      dispatch(fetchHomePage());
    }
  }, [addCompetitorVideo]);

  return (
    <Modal
      size="lg"
      isOpen={open}
      className="Step1AddUrl VideoProcess modal-dialog-centered"
      style={{ maxWidth: "984px" }}
    >
      <ModalHeader
        className="justify-content-end"
        style={{ marginTop: "11rem" }}
      >
        <X
          className="closeBtn"
          style={{ top: "18px", right: "18px" }}
          strokeWidth={1}
          color="black"
          size={50}
          role="button"
          onClick={() => handleClose(!open, "step1Modal")}
        />
      </ModalHeader>
      <ModalBody>
        <>
          <div className="d-flex flex-column align-items-center">
            <div className="mb-3">
              <Link2 color="#6fd1c7" size={35} />
            </div>
            <h1 style={{ fontSize: "24px", color: "black" }}>
              Add {addCompetitorVideo && "Competitor"} Video Link
            </h1>
          </div>
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex flex-column">
              <form onSubmit={handleSubmit}>
                <div className="d-flex justify-content-center mt-5">
                  {URLHandler()}
                </div>
                <div
                  className="d-flex justify-content-center position-absolute field-input-error form-text text-muted live-video-error"
                  style={
                    videoType?.value === "DropBox"
                      ? { margin: "40px 0px 0px 75px" }
                      : {}
                  }
                >
                  {validationErrors.video_url}{" "}
                </div>
                {AllIcons}
                <div
                  className="d-flex flex-column align-items-center"
                  style={{ marginBottom: "43px" }}
                >
                  <>
                    <Button.Ripple
                      type="submit"
                      style={{ height: "56px", minWidth: "178px" }}
                      className={`video-process-btn ${
                        videoType?.value === "DropBox"
                          ? "dropbox-add-video-btn"
                          : "mt-5"
                      } mb-4`}
                      size="lg"
                      disabled={
                        videoType && videoUrls.filter((i) => i).length
                          ? false
                          : true
                      }
                      color={`${
                        videoType && videoUrls.filter((i) => i).length
                          ? "primary"
                          : "secondary"
                      }`}
                    >
                      <span className="d-flex justify-content-center align-items-center gap-1">
                        Add Video {fetchLoading && <Spinner size="sm" />}
                      </span>
                    </Button.Ripple>
                  </>
                  {addCompetitorVideo && uplaodVideoBtn}
                </div>
              </form>
            </div>
            {notificationBand()}
          </div>
        </>
      </ModalBody>
    </Modal>
  );
};

export default Step1AddUrl;
